import { FormLineItem, VendorStatementFormData } from './types';

/**
 * Validate the form data.  Returns an array of errors.
 * @param formData - The form data
 * @param lineItems - The line items
 * @returns - The errors
 */
// eslint-disable-next-line import/prefer-default-export
export const validateForm = (formData: VendorStatementFormData, lineItems: FormLineItem[]) => {
  const errors: string[] = [];
  let missingFields = false;

  // Line items are required
  if (lineItems.length === 0) {
    missingFields = true;
  }

  // Statement date and vendor are required
  if (!formData.statementDate || !formData.vendor) {
    missingFields = true;
  }

  // Total amount is required. Technically allow a zero value, just not an empty value
  if (formData.totalAmountDue === '' || formData.totalAmountDue === null) {
    missingFields = true;
  }

  // Line items must have a date, invoice number, and original invoice amount
  lineItems.forEach((item) => {
    // in this case amount should always be nonzero so we just check for falsy value
    const req = [item.invoiceDate, item.invoiceNumber, item.originalInvoiceAmount];
    if (req.some((field) => !field)) {
      missingFields = true;
    }
  });

  if (missingFields) {
    errors.push('Missing required fields');
  }

  // Sum of line items must match total amount due
  const sumOfLineItems = lineItems.reduce((acc, item) => {
    const debit = parseFloat(item.originalInvoiceAmount) || 0;
    const credit = parseFloat(item.amountPaid) || 0;
    const difference = debit - credit;
    return acc + difference;
  }, 0);

  const roundedSum = Math.round(sumOfLineItems * 100) / 100;
  const roundedTotal = Math.round(parseFloat(formData.totalAmountDue) * 100) / 100;

  if (roundedSum !== roundedTotal) {
    errors.push(
      `Sum of line items (${roundedSum.toFixed(2)}) does not match total amount due (${roundedTotal.toFixed(2)})`,
    );
  }

  return errors;
};
